//#region recipes/leftbar/callbox/callbox_constants.js
var e = { warning: "d-recipe-callbox-badge--warning" }, t = {
	default: "d-recipe-callbox__border-default",
	ai: "d-recipe-callbox__border-ai",
	critical: "d-recipe-callbox__border-critical"
}, n = {
	CALLBOX_BADGE_COLORS: e,
	CALLBOX_BORDER_COLORS: t
};
//#endregion
export { e as CALLBOX_BADGE_COLORS, t as CALLBOX_BORDER_COLORS, n as default };

//# sourceMappingURL=callbox-constants.js.map